module.exports = __webpack_public_path__ + "static/img/必加锁.6ab06b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/product-article/必加锁.png
// module id = 655
// module chunks = 1